import React from 'react'

const CollectionsDashboard = () => {
  return (
    <div>CollectionsDashboard</div>
  )
}

export default CollectionsDashboard